import { render, staticRenderFns } from "./HomeCoaching.vue?vue&type=template&id=5e40712b"
import script from "./HomeCoaching.vue?vue&type=script&lang=js"
export * from "./HomeCoaching.vue?vue&type=script&lang=js"
import style0 from "./HomeCoaching.vue?vue&type=style&index=0&id=5e40712b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports